import { render, staticRenderFns } from "./UhShare.vue?vue&type=template&id=4a85c8ae"
import script from "./UhShare.vue?vue&type=script&setup=true&lang=js"
export * from "./UhShare.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports